import moment from "moment";
export default {
  methods: {
    // Generic Utilities ================================================================
    hex2rgb(hex) {
      // Case of Long(Ex:#FF0000)
      let r = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
      let c = null;
      if (r) {
        c = r.slice(1, 4).map(function(x) {
          return parseInt(x, 16);
        });
      }
      // Case of Short(Ex:#F00)
      r = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
      if (r) {
        c = r.slice(1, 4).map(function(x) {
          return 0x11 * parseInt(x, 16);
        });
      }
      // Not Exist then Return Null
      if (!c) {
        return null;
      }
      return `${c[0]}, ${c[1]}, ${c[2]}`;
    },
    createAPI(path) {
      return (
        import.meta.env.VITE_API_ENDPOINT_PREFIX +
        import.meta.env.VITE_API_STAGE +
        import.meta.env.VITE_API_ENDPOINT_SUFFIX +
        "/" +
        path
      );
    },
    createInternalAPI(path) {
      return (
        import.meta.env.VITE_INTERNALAPI_ENDPOINT_PREFIX +
        import.meta.env.VITE_API_INT_STAGE +
        import.meta.env.VITE_INTERNALAPI_ENDPOINT_SUFFIX +
        "/" +
        path
      );
    },
    roundNumericValue(val, digit) {
      return Number(Number.parseFloat(val).toFixed(digit));
    },
    secondToHour(data, divisor, digit) {
      if (typeof data == "number") {
        return this.roundNumericValue(data / divisor, digit);
      } else {
        return data.map(elm => this.roundNumericValue(elm / divisor, digit));
      }
    },
    // Geo Location Utilities ===========================================================
    // Center Geo Location from Multi Points
    calculateCenterPoint(list) {
      var lon = 0;
      var lat = 0;
      for (var i in list) {
        lon = lon + parseFloat(list[i][0]);
        lat = lat + parseFloat(list[i][1]);
      }
      return [
        parseFloat(lon / (Number(i) + 1)),
        parseFloat(lat / (Number(i) + 1))
      ];
    },
    // Zoom in Area from Multi Points
    calculateFitBound(list) {
      var maxlon = list[0][0];
      var maxlat = list[0][1];

      var minlon = list[0][0];
      var minlat = list[0][1];
      for (var i in list) {
        if (list[i][0] > maxlon) {
          maxlon = list[i][0];
        } else if (list[i][0] < minlon) {
          minlon = list[i][0];
        }

        if (list[i][1] > maxlat) {
          maxlat = list[i][1];
        } else if (list[i][1] < minlat) {
          minlat = list[i][1];
        }
      }
      return [
        [minlon, maxlat],
        [maxlon, minlat]
      ];
    },
    // Station Info Utilities ===========================================================
    getConvertedStationStatus(orgtype, orgstatus) {
      var ret = { type: "", status: "" };
      // House - Full
      if (orgtype == "HouseholdGarbage" && orgstatus == "Full") {
        ret.type = "家庭ごみ";
        ret.status = "未回収";
      }
      // House - Empty
      else if (orgtype == "HouseholdGarbage" && orgstatus == "Empty") {
        ret.type = "家庭ごみ";
        ret.status = "回収済";
      }
      // Recycle(Collect) - Full
      else if (orgtype == "RecycleGarbage" && orgstatus == "Full") {
        ret.type = "資源ごみ";
        ret.status = "未回収";
      }
      // Recycle(Collect) - Empty
      else if (orgtype == "RecycleGarbage" && orgstatus == "Empty") {
        ret.type = "資源ごみ";
        ret.status = "回収/設置済";
      }
      // Recycle(Install) - Full
      else if (orgtype == "RecycleGarbage" && orgstatus == "NoReady") {
        ret.type = "資源ごみ";
        ret.status = "未設置";
      }
      // Recycle(Install) - Empty
      else {
        ret.type = "資源ごみ";
        ret.status = "回収/設置済";
      }
      return ret;
    },
    // Vehicle Info Utilities ===========================================================
    getConvertedVehicleStatus(status) {
      var ret = "停止中";
      // House - Full
      if (status == "Active") {
        ret = "稼働中";
      } else {
        ret = "停止中";
      }

      return ret;
    },

    getConvertedOperationStatus(status) {
      var ret = "作業終了";
      // House - Full
      if (status == "Active") {
        ret = "作業中";
      } else {
        ret = "作業終了";
      }

      return ret;
    },
    // Common Data Utilities ============================================================
    getCurrntEnvAndRegionFromURL(hostStrings) {
      var domain = hostStrings;
      var env = "unknown";
      var region = "unknown";

      // REGION
      // 室蘭市サブドメイン
      if (domain.match("muroran")) {
        region = "muroran";
      } else if (domain.match("kasukabe")) {
        region = "kasukabe";
      } else {
        region = "kasukabe";
      }

      // ENVIRONMENT
      if (domain.match("dev")) {
        env = "開発環境";
      } else if (domain.match("stg")) {
        env = "検証環境";
      } else if (domain.match("preprod")) {
        env = "プレ運用環境";
      } else if (domain.match("clean")) {
        env = "正式運用環境";
      } else {
        env = "不明";
      }

      return { env: env, region: region };
    },
    getCompanyFromId(id) {
      var ret = {
        companyId: id,
        companyName: "パナソニックITS株式会社",
        garbagetype: "HouseholdGarbage"
      };
      if (id == "0") {
        ret.companyName = "桐の樹環境";
        ret.garbagetype = "HouseholdGarbage";
      } else if (id == "1") {
        ret.companyName = "函館市環境";
        ret.garbagetype = "HouseholdGarbage";
      } else if (id == "2") {
        ret.companyName = "あすま商事";
        ret.garbagetype = "HouseholdGarbage";
      } else if (id == "3") {
        ret.companyName = "春日部清掃";
        ret.garbagetype = "HouseholdGarbage";
      } else if (id == "4") {
        ret.companyName = "共栄衛生";
        ret.garbagetype = "HouseholdGarbage";
      } else {
        ret.companyName = "パナソニックITS株式会社";
        ret.garbagetype = "HouseholdGarbage";
      }
      return ret;
    },
    getWeekdayDataFromId(id, type, garbageType, collecttype) {
      var ret = {
        weekdayId: id,
        weekdayType: type,
        weekdayJa: "日",
        weekdayTypaJa: "不明"
      };
      // Household Garbage
      if (garbageType == "HouseholdGarbage") {
        // if     (id == "0" && type=="0"){ret.weekdayJa = "月"; ret.weekdayTypaJa = "区分無し"}
        // else if(id == "1" && type=="0"){ret.weekdayJa = "火"; ret.weekdayTypaJa = "区分無し"}
        // else if(id == "3" && type=="0"){ret.weekdayJa = "木"; ret.weekdayTypaJa = "区分無し"}
        // else if(id == "4" && type=="0"){ret.weekdayJa = "金"; ret.weekdayTypaJa = "区分無し"}
        // else if(id == "2" && type=="1"){ret.weekdayJa = "水"; ret.weekdayTypaJa = "第1週"}
        // else if(id == "2" && type=="2"){ret.weekdayJa = "水"; ret.weekdayTypaJa = "第2週"}
        // else if(id == "2" && type=="3"){ret.weekdayJa = "水"; ret.weekdayTypaJa = "第3週"}
        // else                           {ret.weekdayJa = "日"; ret.weekdayTypaJa = "不明"}
        if     (id == "0"){ret.weekdayJa = "月"; ret.weekdayTypaJa = "区分無し"}
        else if(id == "1"){ret.weekdayJa = "火"; ret.weekdayTypaJa = "区分無し"}
        else if(id == "2"){ret.weekdayJa = "水"; ret.weekdayTypaJa = "区分無し"}
        else if(id == "3"){ret.weekdayJa = "木"; ret.weekdayTypaJa = "区分無し"}
        else if(id == "4"){ret.weekdayJa = "金"; ret.weekdayTypaJa = "区分無し"}
        else if(id == "5"){ret.weekdayJa = "土"; ret.weekdayTypaJa = "区分無し"}
        else              {ret.weekdayJa = "日"; ret.weekdayTypaJa = "不明"}
        // if (id == "0" && type == "0") {
        //   ret.weekdayJa = "月曜";
        //   ret.weekdayTypaJa = "";
        // } else if (id == "1" && type == "0") {
        //   ret.weekdayJa = "火曜";
        //   ret.weekdayTypaJa = "";
        // } else if (id == "3" && type == "0") {
        //   ret.weekdayJa = "木曜";
        //   ret.weekdayTypaJa = "";
        // } else if (id == "4" && type == "0") {
        //   ret.weekdayJa = "金曜";
        //   ret.weekdayTypaJa = "";
        // } else if (id == "2" && type == "1") {
        //   ret.weekdayJa = "第1水曜";
        //   ret.weekdayTypaJa = "";
        // } else if (id == "2" && type == "2") {
        //   ret.weekdayJa = "第2水曜";
        //   ret.weekdayTypaJa = "";
        // } else if (id == "2" && type == "3") {
        //   ret.weekdayJa = "第3水曜";
        //   ret.weekdayTypaJa = "";
        // } else {
        //   ret.weekdayJa = "日曜";
        //   ret.weekdayTypaJa = "";
        // }
      }
      // RecycleGarbage
      else {
        if (collecttype == "0") {
          // Collection
          if (id == "0" && type == "1") {
            ret.weekdayJa = "月曜1（不明）";
            ret.weekdayTypaJa = "";
          } else if (id == "0" && type == "2") {
            ret.weekdayJa = "月曜2（不明）";
            ret.weekdayTypaJa = "";
          } else if (id == "1" && type == "1") {
            ret.weekdayJa = "火曜1（絵鞆～幕西）";
            ret.weekdayTypaJa = "";
          } else if (id == "1" && type == "2") {
            ret.weekdayJa = "火曜2（中島～港北）";
            ret.weekdayTypaJa = "";
          } else if (id == "2" && type == "1") {
            ret.weekdayJa = "水曜1（寿～天神）";
            ret.weekdayTypaJa = "";
          } else if (id == "2" && type == "2") {
            ret.weekdayJa = "水曜2（海岸～母恋南）";
            ret.weekdayTypaJa = "";
          } else if (id == "3" && type == "1") {
            ret.weekdayJa = "木曜1（幌萌～石川）";
            ret.weekdayTypaJa = "";
          } else if (id == "3" && type == "2") {
            ret.weekdayJa = "木曜2（八丁平～柏木）";
            ret.weekdayTypaJa = "";
          } else if (id == "4" && type == "1") {
            ret.weekdayJa = "金曜1（御前水～東）";
            ret.weekdayTypaJa = "";
          } else if (id == "4" && type == "2") {
            ret.weekdayJa = "金曜2（高砂、水元）";
            ret.weekdayTypaJa = "";
          } else {
            ret.weekdayJa = "日曜（不明）";
            ret.weekdayTypaJa = "";
          }
        } else {
          // Installation
          if (id == "0" && type == "1") {
            ret.weekdayJa = "月曜1（絵鞆～幕西）";
            ret.weekdayTypaJa = "";
          } else if (id == "0" && type == "2") {
            ret.weekdayJa = "月曜2（中島～港北）";
            ret.weekdayTypaJa = "";
          } else if (id == "1" && type == "1") {
            ret.weekdayJa = "火曜1（寿～天神）";
            ret.weekdayTypaJa = "";
          } else if (id == "1" && type == "2") {
            ret.weekdayJa = "火曜2（海岸～母恋南）";
            ret.weekdayTypaJa = "";
          } else if (id == "2" && type == "1") {
            ret.weekdayJa = "水曜1（幌萌～石川）";
            ret.weekdayTypaJa = "";
          } else if (id == "2" && type == "2") {
            ret.weekdayJa = "水曜2（八丁平～柏木）";
            ret.weekdayTypaJa = "";
          } else if (id == "3" && type == "1") {
            ret.weekdayJa = "木曜1（御前水～東）";
            ret.weekdayTypaJa = "";
          } else if (id == "3" && type == "2") {
            ret.weekdayJa = "木曜2（高砂、水元）";
            ret.weekdayTypaJa = "";
          } else if (id == "4" && type == "1") {
            ret.weekdayJa = "金曜1（不明）";
            ret.weekdayTypaJa = "";
          } else if (id == "4" && type == "2") {
            ret.weekdayJa = "金曜2（不明）";
            ret.weekdayTypaJa = "";
          } else {
            ret.weekdayJa = "日曜（不明）";
            ret.weekdayTypaJa = "";
          }
        }
      }

      return ret;
    },
    getCollectionTypeFromId(id, companyId) {
      var ret = { collectionId: id, collectionType: "回収" };
      // if (companyId == "0") {
      //   if (id == "0") {
      //     ret.collectionType = "回収";
      //   } else if (id == "1") {
      //     ret.collectionType = "設置";
      //   } else {
      //     ret.collectionType = "不明";
      //   }
      // } else if (companyId == "1") {
      //   if (id == "0") {
      //     ret.collectionType = "燃やせるごみ";
      //   } else if (id == "1") {
      //     ret.collectionType = "燃えないごみ";
      //   } else if (id == "2") {
      //     ret.collectionType = "びん、缶、ペット";
      //   } else if (id == "3") {
      //     ret.collectionType = "プラスチック";
      //   } else {
      //     ret.collectionType = "不明";
      //   }
      // } else {
      //   if (id == "0") {
      //     ret.collectionType = "回収";
      //   } else if (id == "1") {
      //     ret.collectionType = "設置";
      //   } else {
      //     ret.collectionType = "不明";
      //   }
      // }
      return ret;
    },
    getCarNumberDataFromId(carnumber) {
      var carNumberList = this.getHouseReportVehicleOptions("2");
      for (var carNumber of carNumberList) {
        if (carnumber == carNumber.value) {
          return carNumber.text;
        }
      }
      return "";
    },
    getHouseholdWeekdayOptions() {
      return [
        { value: "", text: "すべて" },
        // { value: '00', text: '月(区分無し)'},
        // { value: '10', text: '火(区分無し)'},
        // { value: '30', text: '木(区分無し)'},
        // { value: '40', text: '金(区分無し)'},
        // { value: '21', text: '水(第1週)'},
        // { value: '22', text: '水(第2週)'},
        // { value: '23', text: '水(第3週)'},
        { value: "0", text: "月曜" },
        { value: "1", text: "火曜" },
        { value: "2", text: "水曜" },
        { value: "3", text: "木曜" },
        { value: "4", text: "金曜" },
        { value: "5", text: "土曜" },
      ];
    },
    getRecycleWeekdayOptions() {
      return [
        { value: "", text: "すべて" },
        { value: "01", text: "月(曜日1)" },
        { value: "02", text: "月(曜日2)" },
        { value: "11", text: "火(曜日1)" },
        { value: "12", text: "火(曜日2)" },
        { value: "21", text: "水(曜日1)" },
        { value: "22", text: "水(曜日2)" },
        { value: "31", text: "木(曜日1)" },
        { value: "32", text: "木(曜日2)" },
        { value: "41", text: "金(曜日1)" },
        { value: "42", text: "金(曜日2)" }
      ];
    },
    getCollectionOptions() {
      return [
        { value: 0, text: "すべて" },
        { value: 2, text: "第 1収集地区" },
        { value: 3, text: "第 2収集地区" },
        { value: 4, text: "第 3収集地区" },
        { value: 5, text: "第 4収集地区" },
        { value: 6, text: "第 5収集地区" },
        { value: 7, text: "第 6収集地区" },
        { value: 8, text: "第 7収集地区" },
        { value: 9, text: "第 8収集地区" },
        { value: 10, text: "第 9収集地区" },
        { value: 11, text: "第10収集地区" },
        { value: 12, text: "第11収集地区" },
        { value: 13, text: "第12収集地区" },
      ];
    },
    getCompanyOptions() {
      return [
        { value: "", text: "すべて" },
        { value: "0", text: "桐の樹環境" },
        // { value: "1", text: "函館市環境" },
        { value: "2", text: "あすま商事" },
        { value: "3", text: "春日部清掃" },
        { value: "4", text: "共栄衛生" },
        { value: "8", text: "パナソニックITS株式会社" }
      ];
    },
    getHouseholdCompanyOptions() {
      return [
        { value: "", text: "すべて" },
        { value: "0", text: "桐の樹環境" },
        // { value: "1", text: "函館市環境" },
        { value: "2", text: "あすま商事" },
        { value: "3", text: "春日部清掃" },
        { value: "4", text: "共栄衛生" },
        { value: "8", text: "パナソニックITS株式会社" }
      ];
    },
    getRecycleCompanyOptions() {
      return [
        { value: "", text: "すべて" },
        { value: "6", text: "清掃組合" },
        { value: "7", text: "室蘭市役所" },
        { value: "8", text: "パナソニックITS株式会社" }
      ];
    },
    getReportCompanyOptions() {
      return [
        { value: "0", text: "すべて" },
        { value: "1", text: "桐の樹環境" },
        // { value: "2", text: "函館市環境" },
        { value: "3", text: "あすま商事" },
        { value: "4", text: "春日部清掃" },
        { value: "5", text: "共栄衛生" },
        { value: "7", text: "パナソニックITS株式会社" }
      ];
    },
    getReportHouseholdCompanyOptions() {
      return [
        { value: "0", text: "すべて" },
        { value: "1", text: "桐の樹環境" },
        // { value: "2", text: "函館市環境" },
        { value: "3", text: "あすま商事" },
        { value: "4", text: "春日部清掃" },
        { value: "5", text: "共栄衛生" }
      ];
    },
    getReportRecycleCompanyOptions() {
      return [{ value: "0", text: "すべて" }];
    },
    getReportManagementCompanyOptions() {
      return [
        { value: "6", text: "清掃組合" },
        { value: "7", text: "室蘭市役所" },
        { value: "8", text: "パナソニックITS株式会社" }
      ];
    },

    getOperatorNameList(companyId) {
      var prefix = "XX";
      var list = [{ value: "", text: "" }];
      if (companyId == "0") {
        prefix = "KK"; // Sankyo Seisou
      } else if (companyId == "1") {
        prefix = "DC"; // Dohnan Clean
      } else if (companyId == "2") {
        prefix = "AS"; // Asuma Syouzi
      } else if (companyId == "3") {
        prefix = "KS"; // Kasukabe Seisou
      } else if (companyId == "4") {
        prefix = "KE"; // Kyoei Eisei
      } else if (companyId == "5") {
        prefix = "MS"; // Muroran Seisou
      } else if (companyId == "6") {
        prefix = "CA"; // Muroran Seisou
      } else if (companyId == "7") {
        prefix = "MO"; // Muroran Seisou
      } else if (companyId == "8") {
        prefix = "PITS"; // Panasonic
      } else {
        // None
      }

      for (var i = 0; i < 12; i++) {
        var username = prefix + String(i + 1).padStart(2, "0");
        list.push({ value: username, text: username });
      }
      return list;
    },
    getDatePickerLabels() {
      return {
        labelNoDateSelected: "選択してください",
        labelNoTimeSelected: "未選択",
        labelHelp: "カーソルキーでも設定できます"
      };
    },
    getValidStatus(status) {
      var ret = "無効";
      // House - Full
      if (status == "0") {
        ret = "無効";
      } else {
        ret = "有効";
      }

      return ret;
    },
    getMonthOptions() {
      var current = moment();
      var year = current.year();
      var month = current.month();
      var since_year = 2022;
      var since_month = 9;

      var dataarray = [];

      for (var i = 0; i <= year - since_year; i++) {
        var selectedYear = since_year + i;
        // 最初の年は開始月からスタート
        if (i == 0) {
          for (var j = since_month; j < 12; j++) {
            var datemonth =
              String(selectedYear) + "/" + ("00" + (j + 1)).slice(-2);
            dataarray.push({
              value: datemonth,
              text: datemonth
            });
          }
        }
        //2年目以降は1月から表示対象
        else {
          if (year == selectedYear) {
            // 今月までカウント
            for (var j = 0; j <= month; j++) {
              var datemonth =
                String(selectedYear) + "/" + ("00" + (j + 1)).slice(-2);
              dataarray.push({
                value: datemonth,
                text: datemonth
              });
            }
          } else {
            // 12か月分カウント
            for (var j = 0; j < 12; j++) {
              var datemonth =
                String(selectedYear) + "/" + ("00" + (j + 1)).slice(-2);
              dataarray.push({
                value: datemonth,
                text: datemonth
              });
            }
          }
        }
      }

      return dataarray;
    },
    getYearOptions() {
      var current = moment();
      var year = current.year();
      var since_year = 2021;

      var dataarray = [];

      for (var i = 0; i <= year - since_year; i++) {
        var selectedYear = since_year + i;

        var dateyear = String(selectedYear);
        dataarray.push({
          value: dateyear,
          text: dateyear
        });
      }

      return dataarray;
    },
    getRecycleAreaOptions() {
      return [
        { value: "すべて", text: "すべて" },
        { value: "絵鞆～幕西", text: "絵鞆～幕西" },
        { value: "中島～港北", text: "中島～港北" },
        { value: "寿～天神", text: "寿～天神" },
        { value: "海岸～母恋南", text: "海岸～母恋南" },
        { value: "幌萌～石川", text: "幌萌～石川" },
        { value: "八丁平～柏木", text: "八丁平～柏木" },
        { value: "御前水～東", text: "御前水～東" },
        { value: "高砂、水元", text: "高砂、水元" }
      ];
    },
    getRecycleComponyOptions() {
      return [{ value: "すべて", text: "すべて" }];
    },
    getHouseholdComponyOptions() {
      return [
        { value: "すべて", text: "すべて" },
        { value: "桐の樹環境", text: "桐の樹環境" },
        // { value: "函館市環境", text: "函館市環境" }
        { value: "あすま商事", text: "あすま商事" },
        { value: "春日部清掃", text: "春日部清掃" },
        { value: "共栄衛生", text: "共栄衛生" }
      ];
    },
    getHouseReportVehicleOptions(reportCompanyId) {
      var list = [];

      list.push({ value: "", text: "すべて" });

      // All or 桐の樹環境
      if (reportCompanyId.includes("0") || reportCompanyId.includes("1")) {
        // list.push({ value: "8298", text: "8298" });
        // list.push({ value: "5839", text: "5839" });
        list.push({ value: "593", text: "593" });
        list.push({ value: "594", text: "594" });
        list.push({ value: "922", text: "922" });
        list.push({ value: "923", text: "923" });
        list.push({ value: "924", text: "924" });
      }
      // All or 函館市環境部清掃事業課
      // if (reportCompanyId.includes("0") || reportCompanyId.includes("2")) {
      //   list.push({ value: "01", text: "01" });
      //   list.push({ value: "02", text: "02" });
      //   list.push({ value: "03", text: "03" });
      //   list.push({ value: "04", text: "04" });
      //   list.push({ value: "05", text: "05" });
      //   list.push({ value: "06", text: "06" });
      //   list.push({ value: "07", text: "07" });
      //   list.push({ value: "08", text: "08" });
      //   list.push({ value: "09", text: "09" });
      //   list.push({ value: "10", text: "10" });
      //   list.push({ value: "11", text: "11" });
      //   list.push({ value: "12", text: "12" });
      //   list.push({ value: "13", text: "13" });
      //   list.push({ value: "14", text: "14" });
      //   list.push({ value: "15", text: "15" });
      //   list.push({ value: "16", text: "16" });
      //   list.push({ value: "17", text: "17" });
      //   list.push({ value: "18", text: "18" });
      //   list.push({ value: "19", text: "19" });
      //   list.push({ value: "20", text: "20" });
      //   list.push({ value: "21", text: "21" });
      //   list.push({ value: "22", text: "22" });
      //   list.push({ value: "23", text: "23" });
      //   list.push({ value: "24", text: "24" });
      //   list.push({ value: "25", text: "25" });
      //   list.push({ value: "26", text: "26" });
      //   list.push({ value: "27", text: "27" });
      //   list.push({ value: "28", text: "28" });
      //   list.push({ value: "29", text: "29" });
      //   list.push({ value: "30", text: "30" });
      //   list.push({ value: "31", text: "31" });
      //   list.push({ value: "32", text: "32" });
      //   list.push({ value: "33", text: "33" });
      //   list.push({ value: "34", text: "34" });
      //   list.push({ value: "35", text: "35" });
      //   list.push({ value: "36", text: "36" });
      //   list.push({ value: "37", text: "37" });
      //   list.push({ value: "38", text: "38" });
      //   list.push({ value: "39", text: "39" });
      //   list.push({ value: "40", text: "40" });
      //}
      // All or あすま商事
      if (reportCompanyId.includes("0") || reportCompanyId.includes("3")) {
        list.push({ value: "8225", text: "8225" });
        list.push({ value: "7273", text: "7273" });
        list.push({ value: "9397", text: "9397" });
        list.push({ value: "9876", text: "9876" });
        list.push({ value: "217", text: "217"   });
        list.push({ value: "1620", text: "1620" });
        list.push({ value: "1382", text: "1382" });
        list.push({ value: "1740", text: "1740" });
        list.push({ value: "1297", text: "1297" });
      }
      // All or 春日部清掃
      if (reportCompanyId.includes("0") || reportCompanyId.includes("4")) {
        list.push({ value: "343", text: "343" });
        list.push({ value: "354", text: "354" });
        list.push({ value: "1083", text: "1083" });
        list.push({ value: "2060", text: "2060" });
        list.push({ value: "209", text: "209" });
        list.push({ value: "766", text: "766" });
        list.push({ value: "2059", text: "2059" });
        list.push({ value: "9925", text: "9925" });
        list.push({ value: "758", text: "758" });
        list.push({ value: "1132", text: "1132" });
      }
      // All or 共栄衛生
      if (reportCompanyId.includes("0") || reportCompanyId.includes("5")) {
        list.push({ value: "295", text: "295" });
        list.push({ value: "6817", text: "6817" });
        list.push({ value: "6818", text: "6818" });
        list.push({ value: "8560", text: "8560" });
        list.push({ value: "8337", text: "8337" });
        list.push({ value: "7598", text: "7598" });
        list.push({ value: "1415", text: "1415" });
      }
      // All or 市役所/組合
      if (reportCompanyId.includes("0")) {
        list.push({ value: "1111", text: "1111" });
        list.push({ value: "2222", text: "2222" });
      }
      // All or パナソニック株式会社
      if (reportCompanyId.includes("0") || reportCompanyId.includes("7")) {
        list.push({ value: "3333", text: "3333" });
      }

      return list;
    },
    getRecycleReportVehicleOptions(reportCompanyId) {
      var list = [];

      list.push({ value: "", text: "すべて" });
      // All or 市役所/組合
      if (reportCompanyId.includes("0")) {
        list.push({ value: "1111", text: "1111" });
        list.push({ value: "2222", text: "2222" });
      }
      // All or パナソニック株式会社
      if (reportCompanyId.includes("0") || reportCompanyId.includes("7")) {
        list.push({ value: "3333", text: "3333" });
      }

      return list;
    },

    getRecycleGarbageTypeOptions() {
      return [
        { value: "資源ごみ(設置)", text: "資源ごみ(設置)" },
        { value: "資源ごみ(回収)", text: "資源ごみ(回収)" }
      ];
    },
    // Web Utils
    showErrorMessageToast(title, msg, variant) {
      this.toastCount++;
      // Bootstrap Vue Next対応
      if (this.$bvToast) {
        // Vue 2 + BootstrapVue
        this.$bvToast.toast(msg, {
          title: title,
          autoHideDelay: 5000,
          variant: variant,
          appendToast: true
        });
      } else {
        // Vue 3 + Bootstrap Vue Next - フォールバック
        console.warn(`Toast: ${title} - ${msg}`);
        // 簡易的なアラート表示（実際のtoast実装まで）
        if (typeof window !== 'undefined') {
          setTimeout(() => {
            alert(`${title}\n${msg}`);
          }, 100);
        }
      }
    },
    getLoadingCapacity() {
      return [
        // { carNo: "8298", payLoad: 2000 },
        // { carNo: "5839", payLoad: 3350 },
        { carNo: "593", payLoad: 3150 },
        { carNo: "594", payLoad: 3150 },
        { carNo: "922", payLoad: 2900 },
        { carNo: "923", payLoad: 2900 },
        { carNo: "924", payLoad: 2900 },

        { carNo: "8225", payLoad: 3000 },
        { carNo: "7273", payLoad: 2000 },
        { carNo: "9397", payLoad: 3000 },
        { carNo: "9876", payLoad: 3000 },
        { carNo: "217", payLoad: 3000 },
        { carNo: "1620", payLoad: 3000 },
        { carNo: "1382", payLoad: 3000 },
        { carNo: "1740", payLoad: 3000 },
        { carNo: "1297", payLoad: 3000 },

        { carNo: "343", payLoad: 4000 },
        { carNo: "354", payLoad: 2000 },
        { carNo: "1083", payLoad: 4000 },
        { carNo: "2060", payLoad: 3000 },
        { carNo: "209", payLoad: 3000 },
        { carNo: "766", payLoad: 3000 },
        { carNo: "2059", payLoad: 3000 },
        { carNo: "9925", payLoad: 3000 },
        { carNo: "758", payLoad: 3000 },
        { carNo: "1132", payLoad: 3000 },

        { carNo: "295", payLoad: 3000 },
        { carNo: "6817", payLoad: 4000 },
        { carNo: "6818", payLoad: 4000 },
        { carNo: "8560", payLoad: 4000 },
        { carNo: "8337", payLoad: 3000 },
        { carNo: "7598", payLoad: 3000 },
        { carNo: "1415", payLoad: 3000 },

        { carNo: "01", payLoad: 2000 },
        { carNo: "02", payLoad: 2000 },
        { carNo: "03", payLoad: 2000 },
        { carNo: "04", payLoad: 2000 },
        { carNo: "05", payLoad: 2000 },
        { carNo: "06", payLoad: 2000 },
        { carNo: "07", payLoad: 2000 },
        { carNo: "08", payLoad: 2000 },
        { carNo: "09", payLoad: 2000 },
        { carNo: "10", payLoad: 2000 },
        { carNo: "11", payLoad: 2000 },
        { carNo: "12", payLoad: 2000 },
        { carNo: "13", payLoad: 2000 },
        { carNo: "14", payLoad: 2000 },
        { carNo: "15", payLoad: 2000 },
        { carNo: "16", payLoad: 2000 },
        { carNo: "17", payLoad: 2000 },
        { carNo: "18", payLoad: 2000 },
        { carNo: "19", payLoad: 2000 },
        { carNo: "20", payLoad: 2000 },
        { carNo: "21", payLoad: 2000 },
        { carNo: "22", payLoad: 2000 },
        { carNo: "23", payLoad: 2000 },
        { carNo: "24", payLoad: 2000 },
        { carNo: "25", payLoad: 2000 },
        { carNo: "26", payLoad: 2000 },
        { carNo: "27", payLoad: 2000 },
        { carNo: "28", payLoad: 2000 },
        { carNo: "29", payLoad: 2000 },
        { carNo: "30", payLoad: 2000 },
        { carNo: "31", payLoad: 2000 },
        { carNo: "32", payLoad: 2000 },
        { carNo: "33", payLoad: 2000 },
        { carNo: "34", payLoad: 2000 },
        { carNo: "35", payLoad: 2000 },
        { carNo: "36", payLoad: 2000 },
        { carNo: "37", payLoad: 2000 },
        { carNo: "38", payLoad: 2000 },
        { carNo: "39", payLoad: 2000 },
        { carNo: "40", payLoad: 2000 },
        { carNo: "1111", payLoad: 2000 },
        { carNo: "2222", payLoad: 2000 },
        { carNo: "3333", payLoad: 2000 }
      ];
    },
    getReportTemplate() {
      return {
        ServiceEndTime: "",
        ServiceEndTimeKind: "2",
        ServiceStartTime: "",
        ServiceStartTimeKind: "2",
        collectClassification: [
          {
            brownBottles: 0,
            dangerousObjects: 0,
            emptyCans: 0,
            otherBottes: 0,
            petBottles: 0,
            remarks: "",
            stationCounts: 0,
            transparentBottles: 0,
            workEndTime: "",
            workStartTime: ""
          },
          {
            brownBottles: 0,
            dangerousObjects: 0,
            emptyCans: 0,
            otherBottes: 0,
            petBottles: 0,
            remarks: "",
            stationCounts: 0,
            transparentBottles: 0,
            workEndTime: "",
            workStartTime: ""
          },
          {
            brownBottles: 0,
            dangerousObjects: 0,
            emptyCans: 0,
            otherBottes: 0,
            petBottles: 0,
            remarks: "",
            stationCounts: 0,
            transparentBottles: 0,
            workEndTime: "",
            workStartTime: ""
          }
        ],
        collectionArea: "",
        collectionDate: "",
        company: "",
        companyNumber: "",
        createAt: "",
        dataNo: "",
        dataType: "dailyReport",
        dirtObject: [
          {
            combustibleWeight: -1,
            kamishiroCheck: "0",
            loadingStatus: "0",
            nonburnableWeight: -1,
            workEndTime: "",
            workStartTime: ""
          },
          {
            combustibleWeight: -1,
            kamishiroCheck: "0",
            loadingStatus: "0",
            nonburnableWeight: -1,
            workEndTime: "",
            workStartTime: ""
          },
          {
            combustibleWeight: -1,
            kamishiroCheck: "0",
            loadingStatus: "0",
            nonburnableWeight: -1,
            workEndTime: "",
            workStartTime: ""
          },
          {
            combustibleWeight: -1,
            kamishiroCheck: "0",
            loadingStatus: "0",
            nonburnableWeight: -1,
            workEndTime: "",
            workStartTime: ""
          },
          {
            combustibleWeight: -1,
            kamishiroCheck: "0",
            loadingStatus: "0",
            nonburnableWeight: -1,
            workEndTime: "",
            workStartTime: ""
          },
          {
            combustibleWeight: -1,
            kamishiroCheck: "0",
            loadingStatus: "0",
            nonburnableWeight: -1,
            workEndTime: "",
            workStartTime: ""
          }
        ],
        driverName: ["", "", ""],
        garbageKindNo: "",
        installationClassification: [
          {
            brownBottles: 0,
            dangerousObjects: 0,
            emptyCans: 0,
            otherBottes: 0,
            petBottles: 0,
            remarks: "",
            stationCounts: 0,
            transparentBottles: 0,
            workEndTime: "",
            workStartTime: ""
          },
          {
            brownBottles: 0,
            dangerousObjects: 0,
            emptyCans: 0,
            otherBottes: 0,
            petBottles: 0,
            remarks: "",
            stationCounts: 0,
            transparentBottles: 0,
            workEndTime: "",
            workStartTime: ""
          },
          {
            brownBottles: 0,
            dangerousObjects: 0,
            emptyCans: 0,
            otherBottes: 0,
            petBottles: 0,
            remarks: "",
            stationCounts: 0,
            transparentBottles: 0,
            workEndTime: "",
            workStartTime: ""
          }
        ],
        operatorName: ["", "", ""],
        restTimeInwork: "",
        restTimeOutwork: "",
        routeId: "",
        targetNo: "",
        travelDistance: 0,
        travelDistanceKind: "2",
        allRestTime: ""
      };
    },

    // Report Data Utilities ============================================================
    getDashbardurlRequestID() {
      var ret = "ac67cae8-f5fc-43c5-b82a-0d2c155f5078"; // Staging - Report Dashboard
      if (process.env.API_INT_STAGE == "dev") {
        ret = "a1bd1cca-2c27-4bee-8881-8b6ec4ae43ee";
      } // Dev     - Report Dashboard
      else if (process.env.API_INT_STAGE == "stg") {
        ret = "ac67cae8-f5fc-43c5-b82a-0d2c155f5078";
      } // Staging - Report Dashboard
      else if (process.env.API_INT_STAGE == "") {
        ret = "07e967f0-3c19-40b1-85a5-a284a7971ed5";
      } // Prod    - Report Dashboard
      else {
      }
      return ret;
    },
    // 家庭ごみ集計
    getEmbedDashbordSheetIdOfHouseholdDaily() {
      var ret =
        "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_4f3996bb-ad78-4bc2-b2ad-35fd3cf22bc4"; // Staging - Report Dashboard
      if (process.env.API_INT_STAGE == "dev") {
        ret =
          "a1bd1cca-2c27-4bee-8881-8b6ec4ae43ee_df24a77d-3109-420c-96af-bcba76240fa2";
      } // Dev     - Report Dashboard
      else if (process.env.API_INT_STAGE == "stg") {
        ret =
          "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_4f3996bb-ad78-4bc2-b2ad-35fd3cf22bc4";
      } // Staging - Report Dashboard
      else if (process.env.API_INT_STAGE == "") {
        ret =
          "07e967f0-3c19-40b1-85a5-a284a7971ed5_bf3379f2-0926-43bb-8da2-fdf956008779";
      } // Prod    - Report Dashboard
      else {
      }
      return ret;
    },
    // 家庭ごみ月報(集計)
    getEmbedDashbordSheetIdOfHouseholdMonthly() {
      var ret =
        "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_f5732d8c-22dc-4124-b54e-0d078d1d3445"; // Staging - Report Dashboard
      if (process.env.API_INT_STAGE == "dev") {
        ret =
          "a1bd1cca-2c27-4bee-8881-8b6ec4ae43ee_fcf4074e-b925-4781-a729-a0c5774c227c";
      } // Dev     - Report Dashboard
      else if (process.env.API_INT_STAGE == "stg") {
        ret =
          "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_f5732d8c-22dc-4124-b54e-0d078d1d3445";
      } // Staging - Report Dashboard
      else if (process.env.API_INT_STAGE == "") {
        ret =
          "07e967f0-3c19-40b1-85a5-a284a7971ed5_2bc048cd-f317-4a8e-9fa7-e4c8957f1b7f";
      } // Prod    - Report Dashboard
      else {
      }
      return ret;
    },
    // 家庭ごみ年報(集計)
    getEmbedDashbordSheetIdOfHouseholdYearly() {
      var ret =
        "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_2f48c709-aec6-4718-b9a7-6d9a3e2e8446"; // Staging - Report Dashboard
      if (process.env.API_INT_STAGE == "dev") {
        ret =
          "a1bd1cca-2c27-4bee-8881-8b6ec4ae43ee_84809ba8-03af-4c37-adff-7a07f16d5b6a";
      } // Dev     - Report Dashboard
      else if (process.env.API_INT_STAGE == "stg") {
        ret =
          "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_2f48c709-aec6-4718-b9a7-6d9a3e2e8446";
      } // Staging - Report Dashboard
      else if (process.env.API_INT_STAGE == "") {
        ret =
          "07e967f0-3c19-40b1-85a5-a284a7971ed5_11aa2db7-4608-4cef-8482-ef09802b0e02";
      } // Prod    - Report Dashboard
      else {
      }
      return ret;
    },
    // 資源ごみ集計
    getEmbedDashbordSheetIdOfRecycleDaily() {
      var ret =
        "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_1e36f0c1-4192-411b-857f-378eaf753d50"; // Staging - Report Dashboard
      if (process.env.API_INT_STAGE == "dev") {
        ret =
          "a1bd1cca-2c27-4bee-8881-8b6ec4ae43ee_1ddc66b2-8be2-4c41-b9c5-8591ea561b65";
      } // Dev     - Report Dashboard
      else if (process.env.API_INT_STAGE == "stg") {
        ret =
          "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_1e36f0c1-4192-411b-857f-378eaf753d50";
      } // Staging - Report Dashboard
      else if (process.env.API_INT_STAGE == "") {
        ret =
          "07e967f0-3c19-40b1-85a5-a284a7971ed5_ec3d495c-4838-4d6b-be1d-b4b73f986367";
      } // Prod    - Report Dashboard
      else {
      }
      return ret;
    },
    // 資源ごみ月報(集計)
    getEmbedDashbordSheetIdOfRecycleMonthly() {
      var ret =
        "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_d413cb59-de4b-4b11-ac86-c701d41db927"; // Staging - Report Dashboard
      if (process.env.API_INT_STAGE == "dev") {
        ret =
          "a1bd1cca-2c27-4bee-8881-8b6ec4ae43ee_5b85610d-ff45-4a03-9665-d1ac76b3fc6e";
      } // Dev     - Report Dashboard
      else if (process.env.API_INT_STAGE == "stg") {
        ret =
          "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_d413cb59-de4b-4b11-ac86-c701d41db927";
      } // Staging - Report Dashboard
      else if (process.env.API_INT_STAGE == "") {
        ret =
          "07e967f0-3c19-40b1-85a5-a284a7971ed5_d9e0a3b9-6cbf-4bd8-a049-c21699e2eb52";
      } // Prod    - Report Dashboard
      else {
      }
      return ret;
    },
    // 資源ごみ年報(集計)
    getEmbedDashbordSheetIdOfRecycleYearly() {
      var ret =
        "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_b3a415fd-0462-4286-90d0-5bf1544eca24"; // Staging - Report Dashboard
      if (process.env.API_INT_STAGE == "dev") {
        ret =
          "a1bd1cca-2c27-4bee-8881-8b6ec4ae43ee_384bad44-e86e-43d6-a660-e218f7fb5f67";
      } // Dev     - Report Dashboard
      else if (process.env.API_INT_STAGE == "stg") {
        ret =
          "ac67cae8-f5fc-43c5-b82a-0d2c155f5078_b3a415fd-0462-4286-90d0-5bf1544eca24";
      } // Staging - Report Dashboard
      else if (process.env.API_INT_STAGE == "") {
        ret =
          "07e967f0-3c19-40b1-85a5-a284a7971ed5_9635b5f2-5b7e-4460-b1e2-3109bc3cab19";
      } // Prod    - Report Dashboard
      else {
      }
      return ret;
    },
    // Common Language Set Utilities ====================================================

    // GPS Utilities ====================================================================

    // AWS Utilities ====================================================================

    /**
     * ログ出力機能（1分ごとにS3のwaste-webapp-logバケットにログを出力）
     * @param {*} logLevel 基本的には"TOPIC"を使用
     * @param {*} message 出力するログメッセージ
     */
    putLogMessage(logLevel, message) {
      const nowDate = new Date();
      const nowDateStr = this.getYYYYMMDDHHMMSS(nowDate);
      message = "[" + logLevel + "] " + nowDateStr + " " + message + "\n";

      let messageList = [];
      const messageString = sessionStorage.getItem("logMessageList");
      if (messageString != null) {
        messageList = messageString.split(",");
      }

      messageList.push(message);
      sessionStorage.setItem("logMessageList", messageList);
    },

    /**
     * 日付→文字列変換
     * @param {*} date
     * @returns yyyy/MM/dd hh:mm:ss
     */
    getYYYYMMDDHHMMSS(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const hour = date
        .getHours()
        .toString()
        .padStart(2, "0");
      const minute = date
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const second = date
        .getSeconds()
        .toString()
        .padStart(2, "0");

      return (
        year +
        "/" +
        month +
        "/" +
        day +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
    isInteger(numVal) {
      // チェック条件パターン
      var pattern = /^([1-9]\d*|0)$/;
      // 数値チェック
      return pattern.test(numVal);
    },
    isDecimal(numVal) {
      // チェック条件パターン: 小数点以下最大4桁を許可
      var pattern = /^([1-9]\d*|0)(\.\d{1,3})?$/;
      // 数値チェック
      return pattern.test(numVal);
    },

    // CLAS-2563 収集地区名
    getCollectionArea(id) {
      var ret = {
        areaNumber : id,
        areaName: "パナソニックITS株式会社",
      };
      if (id == "00") {
        ret.areaName = "あすま（月水金）";
      } else if (id == "01") {
        ret.areaName = "あすま（火木土）";
      } else if (id == "02") {
        ret.areaName = "春日部（月水金）";
      } else if (id == "03") {
        ret.areaName = "春日部（火木土）";
      } else if (id == "04") {
        ret.areaName = "桐の樹（月水金）";
      } else if (id == "05") {
        ret.areaName = "桐の樹（火木土）";
      } else if (id == "06") {
        ret.areaName = "共栄衛生（月水金）";
      } else if (id == "07") {
        ret.areaName = "共栄衛生（火木土）";
      } else {
        ret.areaName = "パナソニックITS株式会社";
      }
      return ret;
    },
  }
};
